
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/tooltip';
import './vendor/fslightbox.js';

import { Carousel } from 'bootstrap';
import {WidgetLoader, asClassWidget} from './core/widgetLoader';
import SwiperWidget from './widgets/SwiperWidget';
import { Tooltip } from 'bootstrap';

document.querySelectorAll('[data-bs-toggle="tooltip"]')
	.forEach(el => new Tooltip(el));

const registry = [
	asClassWidget('[data-app-swiper]', SwiperWidget),
];

const loader = new WidgetLoader(registry);

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		loader.init();
	});
} else {
	loader.init();
}

document.addEventListener('DOMContentLoaded', () => {
	const forms = document.querySelectorAll('.needs-validation');
	console.log("Im loaded");

	//Fixed header
	const header = document.querySelector('header'); // uprav selector podla tvojho headeru

	window.addEventListener('scroll', () => {
		header.classList.toggle('sticky', window.scrollY > 0);
	});


	// Preloader
	const loadingMask = document.querySelector('#loadingMask');
	if (loadingMask) {
		loadingMask.style.transition = 'opacity 0.3s';
		loadingMask.style.opacity = '0';
		setTimeout(() => loadingMask.style.display = 'none', 300);
	}

	// Carousel
	const carouselEl = document.querySelector('#carouselExample');
	if (carouselEl) {
		const carousel = new Carousel(carouselEl, {
			interval: 5000,
			ride: 'carousel',
			wrap: true,
			pause: 'hover'
		});

		const wrapper = carouselEl.closest('.carousel-wrapper');
		const prevBtn = wrapper.querySelector('.carousel-control-prev');
		const nextBtn = wrapper.querySelector('.carousel-control-next');

		prevBtn.classList.add('is-active');
		nextBtn.classList.add('is-active');
	}

	Array.from(forms).forEach(form => {
		form.addEventListener('submit', event => {
			if (!form.checkValidity()) {
				event.preventDefault();
				event.stopPropagation();
			}
			form.classList.add('was-validated');
		}, false);
	});


	// FsLightbox
	setTimeout(() => {
		if (window.fsLightboxInstances) {
			Object.keys(window.fsLightboxInstances).forEach(key => {
				window.fsLightboxInstances[key].props.showThumbsOnMount = true;
			});
		}
	}, 500);


});